module.exports = {"RELEASE":1546452811915,"VERSION":"1.0.0","COGNITO_POOL_DETAILS":{"UserPoolId":"us-east-1_d6ZZDefrc","ClientId":"2k7iqfpa5p3ovajj9po27gfd8f"},"API_URL":"https://api.p2p-games.org"};


// WEBPACK FOOTER //
// external "{/"RELEASE/":1546452811915,/"VERSION/":/"1.0.0/",/"COGNITO_POOL_DETAILS/":{/"UserPoolId/":/"us-east-1_d6ZZDefrc/",/"ClientId/":/"2k7iqfpa5p3ovajj9po27gfd8f/"},/"API_URL/":/"https:/api.p2p-games.org/"}"